import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/Basics/MDButton";

import { EditNote, Public, TaskAlt } from "@mui/icons-material";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { statusLabels, PUBLISHED, VALIDATED } from "contants";
import { Chip } from "@mui/material";
import { t } from "i18next";
import MDBox from "components/Basics/MDBox";
import { useDispatch } from "react-redux";
import SourceActions from "redux-react/actions/sourceActions";

const ChangeStatusDialog = ({ open, onClose, listIds, reloadAssets }) => {
	const dispatch = useDispatch();

	const statusIcons = {
		[PUBLISHED]: <Public fontSize="small" />,
		[VALIDATED]: <TaskAlt fontSize="small" />
	};

	const getStatusColor = value => {
		if (value === "draft") return "warning";
		if (value === "published") return "success";
		return "info";
	};

	const handleChange = value => {
		dispatch(
			SourceActions.updateAssets(
				listIds,
				{
					status: value
				},
				() => {
					reloadAssets();
					onClose();
				}
			)
		);
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="asset-selection-dialog-title"
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle
				id="asset-selection-dialog-title"
				sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
			>
				{t("ASSETS.ACTIONS.changeStatusTitle")}
				<IconButton aria-label="close" onClick={onClose} sx={{ color: "#666" }}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers>
				{statusLabels.map(option => (
					<MDBox m={1}>
						<Chip
							label={t(option.label)}
							size="large"
							color={getStatusColor(option.value)}
							variant="outlined"
							onClick={() => handleChange(option.value)}
							icon={statusIcons[option.value] || <EditNote fontSize="small" />}
							sx={{
								width: "30%"
							}}
						/>
					</MDBox>
				))}
			</DialogContent>

			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={onClose}>
					{t("SETTINGS.cancel")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

export default ChangeStatusDialog;
